export const offlineInboxUrl = "/api/live-chat/offline";
export type OfflineMessage = {
  id: string; name: string; email: string; messageBody: string;
  status: string; createdAt: string;
};
type Request = (method: string, url: string) => Promise<Response>;
export class OfflineInboxError extends Error {
  constructor(public status: number) { super(`Offline inbox HTTP ${status}`); }
}
export async function requestOfflineInbox(method: string, url: string, token: string | null): Promise<Response> {
  const response = await fetch(url, {
    method, credentials: "include",
    headers: { Authorization: `Bearer ${token || ""}` },
  });
  // Preserve HTTP status locally: the shared apiRequest turns it into prose.
  if (!response.ok) throw new OfflineInboxError(response.status);
  return response;
}
export async function loadOfflineInbox(request: Request): Promise<OfflineMessage[]> {
  return (await request("GET", offlineInboxUrl)).json();
}
export async function handleOfflineMessage(request: Request, id: string) {
  return (await request("POST", `${offlineInboxUrl}/${encodeURIComponent(id)}/handle`)).json();
}
export function offlineInboxError(error: unknown): string {
  const status = error instanceof OfflineInboxError ? String(error.status) : String(error instanceof Error ? error.message : error);
  if (/^401\b/.test(status)) return "Your session has expired. Please sign in again.";
  if (/^403\b/.test(status)) return "You do not have permission to manage offline messages.";
  return "The request failed. Please try again.";
}
